<template>
  <div>
    <el-form v-model="formData" label-width="100px" size="small">
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.table_search_label_production_order_goods_no') ||
                '产品编号'
            "
          >
            <b-form-input
              size="sm"
              :placeholder="
                $l('INDEX.table_search_placeholder_production_ordergoodsno') ||
                  '请输入产品编号/产品识别编号'
              "
              clearable
              type="search"
              v-model.trim="formData.orderGoodsNo"
              @keyup.enter="query()"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="
              $l('INDEX.table_search_label_production_order_goods_name') ||
                '产品名称'
            "
          >
            <b-form-input
              size="sm"
              :placeholder="
                $l(
                  'INDEX.table_search_placeholder_production_order_goods_no'
                ) || '请输入产品中文名称/产品英文名称'
              "
              clearable
              type="search"
              v-model.trim="formData.orderGoodsName"
              @keyup.enter="query()"
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <b-button
            class="mr-2"
            size="sm"
            variant="outline-primary"
            @click="query()"
          >
            {{ $l('INDEX.btn_search') || '搜索' }}
          </b-button>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  data() {
    return { formData: {} }
  },
  mounted() {
    this.query()
  },
  methods: {
    query() {
      this.$emit('query', this.formData)
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form .el-form-item {
  margin-bottom: 0 !important;
}
</style>
